/* eslint-disable no-unused-vars */

<template>
  <div>
    <span v-if="isReady">
      <grid-layout
        :layout.sync="layout"      
        :cols="this.layout2.gridMonitoringConfiguration.breakpointConfiguration"
        :row-height="this.layout2.gridMonitoringConfiguration.rowHeight"
        :is-draggable="this.layout2.gridMonitoringConfiguration.isDraggable"
        :is-resizable="this.layout2.gridMonitoringConfiguration.isResizable"
        :is-mirrored="this.layout2.gridMonitoringConfiguration.isMirrored"
        :vertical-compact="layout2.gridMonitoringConfiguration.verticalCompact"
        :margin="[this.layout2.gridMonitoringConfiguration.xMargin, this.layout2.gridMonitoringConfiguration.yMargin]"
        :use-css-transforms="this.layout2.gridMonitoringConfiguration.cssTransforms"
        :preventCollision="this.layout2.gridMonitoringConfiguration.preventCollision"
        :responsive="this.layout2.gridMonitoringConfiguration.responsive"
      >
        <grid-item 
          v-for="item in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :minH=195
          :key="item.i"    
          class="card"
        >
            <div class="row1">
              <div class="row1Col1">{{ item.name }}</div>
              <div class="row1Col2" v-if="item.initials">({{ item.initials }})</div>
              <div></div>
            </div>      
            <div :class="[{ alertBackground: item.alert, normalBackground: !item.alert, row2: true }]">
              <div class="row2Col">{{ item.total }}</div>
            </div>      
            <div class="row3"> 
                <DonutChart class="row3Col1" :graphConfig="pieConfig" :chartHeight="chartHeight" :series="[(item.total-item.delayed),item.delayed]"></DonutChart>
              <div class="row3Col2">
                  <div class="row3Col2Txt1">NO PRAZO</div>
                  <div :class="[{normalAdherence: !item.alert, row3Col2Txt2: true}]">{{ 100 - item.delayedAdherence | numberFormat }} %</div> 
                  <div class="row3Col2Txt1">EM ATRASO</div>
                  <div :class="[{alertAdherence: item.alert, row3Col2Txt2: true}]">{{ item.delayedAdherence | numberFormat }} %</div> 
              </div>
            </div>
        </grid-item>
      </grid-layout>
    </span>
    <span v-else>
      <b-row class="waitTxt">{{ $t('aguardando-banco-de-dados') }}</b-row>
    </span>
  </div>
</template>

<script>

import VueGridLayout from "vue-grid-layout";
import DonutChart from "../utils/Chats/DonutChart.vue"
import { urlMainAPI, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import { rotationScreenMixin } from "../mixins/rotationScreenMixin"
import axios from "axios";

export default {
  name: "GridOccurrenceMonitoring",
  mixins: [ rotationScreenMixin ],
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    DonutChart,
  },
  computed: mapState(["msg"]),
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.display = to.params.display;
      this.loadGridOccurrenceMonitoring();
    },
  },
  data() {
    return {
      display: this.$route.params.display,
      canShowFooter: true,
      isReady: false,
      pieConfig: {
        type: "pie",
        width: "100",
        height: "115"
      },
      minHeightForItens: 195,
      templateWidth: 0,
      chartHeight: 0,
      layout: [],
      layout2: {
        indicatorMonitoringGroup: {
          timestamp: "",
        },
        gridMonitoringConfiguration: {
          qtyColumns: 1,
          colNum: 4
        },
      },    
    };
  },
  filters: {
    numberFormat(num) {
      try {
        num = num.toString()
        if(num.includes(",")){
          num = num.replace(',', '.')
        }
        if(!isNaN(parseFloat(num))){
          var numParsed = parseFloat(num); 
          if (numParsed >= 100000 || numParsed <= -100000)
            return numParsed.toExponential(3)             
          if (numParsed > 0 && numParsed < 1 || numParsed < 0 && numParsed > -1){
            numParsed = numParsed.toFixed(4);
          } else {
            numParsed = numParsed.toFixed(2);
          }
          numParsed = numParsed.replace('.', ',').split(",")
          let v1 = numParsed[0]
          let v2 = numParsed[1]
          v1 = v1.split("").reverse()
          let i = 0
          var stop = 0
          if (v1.length/3 >= 1 && v1.length%3 != 0){
            i = 1;
            stop = Math.trunc(v1.length/3);
          }
          if (v1.length/3 >= 1 && v1.length%3 == 0){
            i = 1;
            stop = Math.trunc(v1.length/3)-1
          }
          var pos = 3
          if(i >= 1){
            for (i; i <= stop; i++){
              v1.splice(pos, 0, ".");
              pos = pos + 4;
            }
          }
          numParsed = v1.reverse().join("") + ',' + v2
          if(numParsed.includes("-.")){
            numParsed = numParsed.replace("-.","-");            
          }
          return numParsed
        }
        return "-"
      } catch (error) {
        return "-"
      }
    }        
  },
  methods: {    
    async loadGridOccurrenceMonitoring() {
      this.isReady = false;   
         defaultSuccess(this.$t('carregando-dados'));       
        const url = `${urlMainAPI}/getoccurrencemonitoring/${this.display}`;
        await axios
          .get(url)
          .then((res) => {
            // this.layout = JSON.parse(res.data);
            if(this.canShowFooter){
               defaultSuccess(this.$t('dados-carregados'));
              this.layout = res.data.vwOccurrenceMonitoringList;
              this.layout2 = res.data;
              this.$store.commit("setMsg", `ÚLTIMA ATUALIZAÇÃO: ${this.dateBR(this.layout2.timestamp)}`);
              // this.$store.commit("setMsg2", this.reliability);              
            }
          })
          .catch((error) => {
              console.log("Erro na tela de monitoramento: " + error)
          });
          this.isReady = true;              
    },
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ")
      dateBr = info[0];
      let time = info[1].substring(0,5)
      if (dateBr == "Invalid" || date == "1900-01-01 00:00:00") {
        return "Aguardando dados do servidor ";
      } else {
        return dateBr = dateBr + " " + time;
      }
    },
    // eslint-disable-next-line no-unused-vars
    moveEvent: function(i, newX, newY) {
    },
    // eslint-disable-next-line no-unused-vars
    resizeEvent: function(i, newH, newW, newHPx, newWPx) {      
    },
    // eslint-disable-next-line no-unused-vars
    movedEvent: function(i, newX, newY) {
    },
    /**
     *
     * @param i the item id/index
     * @param newH new height in grid rows
     * @param newW new width in grid columns
     * @param newHPx new height in pixels
     * @param newWPx new width in pixels
     *
     */
    // eslint-disable-next-line no-unused-vars
    resizedEvent: function(i, newH, newW, newHPx, newWPx) {      
    },
    // eslint-disable-next-line no-unused-vars
    containerResizedEvent: function(i, newH, newW, newHPx, newWPx) {      
    },
  },  
  async created(){
    await this.loadGridOccurrenceMonitoring();
    this.startRotation();

    this.chartHeight = document.querySelector(".card").offsetHeight - (50+40+4)
    // eslint-disable-next-line no-unused-vars
    document.querySelectorAll(".row3").forEach((element, index, array) => {
      element.style.height = `${this.chartHeight}px`
      element.style.maxHeight = `${this.chartHeight}px`
    })
    // eslint-disable-next-line no-unused-vars
    document.querySelectorAll(".row3Col1").forEach((element, index, array) => {
      element.style.height = `${this.chartHeight}px`
      element.style.maxHeight = `${this.chartHeight}px`
    })
  },

  beforeDestroy(){
    this.canShowFooter = false;
    this.$store.commit("setMsg", " ")
    this.stopRotation();
  }
};
</script>

<style scoped>

.card {
  display: grid;
  font-weight: bold;
  border: 2px solid black;
  background-color: antiquewhite;
  overflow: hidden;
  grid-template-rows: 40px 50px auto;
}

.alertBackground {
  background-color: #d11e1d;
  color: rgb(255, 255, 255);
}

.normalBackground {
  background-color: rgb(0, 0, 0);
  color: rgb(255, 255, 255);
}

.alertAdherence {
  color: #d11e1d;
}

.normalAdherence {
  color: rgb(0, 0, 0);
}

.row1{
  display: grid;
  grid-template-columns: 1fr 75px;
  text-transform: uppercase;
  font-size: 1.3em;  
  color: black;
  background-color: white;
  /* letter-spacing: 0.8px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;  
}

.row1Col1 {  
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
}

.row1Col2 {
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 75px;
  max-width: 75px;
}

.row2{
  width: 100%;  
  align-items: center;
}

.row2Col {  
  display: flex;
  justify-content: center;
  font-size: 1.9em;
  height: 50px;
  align-items: center;
}

.row3{
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  align-items: center;
}

.row3Col1{
  text-align: center;
  align-items: center;  
}

.row3Col2{
  display: grid;
  grid-template-rows: auto auto auto auto; 
  text-align: center;
  align-content: center; 
  width: 100%;
}

.row3Col2Txt1{
  text-align: center;
  align-self: flex-end;
}

.row3Col2Txt2{
  text-align: center;
  align-self: flex-start;
  font-size: 1.0em;
}

.infoTXT{
  color: black;
}


.waitTxt {
  display: flex;
  justify-content: center;
  /* font-weight: bold; */
  background: black;
  color: white;
  margin-bottom: 10px;
}



/* @media only screen and (max-width: 800px) {

} */

</style>

